'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import type { SaveWelloCommentResponse } from '@generated/auth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthApi, type COMMENT_TYPE } from '@/api';
import { toContentIdQuery } from '@/api/getCommentList';
interface UsePostCommentMutationParams {
  /** 댓글 API에서 댓글 대상 카테고리로 사용 */
  commentType: COMMENT_TYPE;
  /** 댓글이 달리는 컨텐츠 id */
  contentId: number | string;
  /** 답글일 때 부모 댓글 id */
  parentCommentId?: number;
  /** 답글 트리의 최상위 댓글 id */
  rootCommentId?: number;
  /** 성공 시 상위 composer에 응답을 전달 */
  onSuccess?: (response?: SaveWelloCommentResponse) => void;
}

// 신규 댓글/답글 작성과 관련 쿼리 무효화를 함께 처리한다.
export const usePostCommentMutation = t0 => {
  const $ = _c(15);
  const {
    commentType,
    contentId,
    parentCommentId,
    rootCommentId,
    onSuccess
  } = t0;
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== commentType || $[1] !== contentId || $[2] !== parentCommentId || $[3] !== rootCommentId) {
    t1 = contents => AuthApi["post:/wello/v2/auth/wello-comment"]({
      body: {
        commentTypeCd: commentType,
        contents,
        parentWelloCommentId: parentCommentId,
        rootWelloCommentId: rootCommentId,
        ...toContentIdQuery(contentId)
      }
    });
    $[0] = commentType;
    $[1] = contentId;
    $[2] = parentCommentId;
    $[3] = rootCommentId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onSuccess || $[6] !== queryClient || $[7] !== toast) {
    t2 = async t3 => {
      const {
        data
      } = t3;
      toast({
        type: "success",
        message: "\uB313\uAE00 \uB4F1\uB85D\uC644\uB8CC"
      });
      await queryClient.invalidateQueries();
      onSuccess?.(data?.context);
    };
    $[5] = onSuccess;
    $[6] = queryClient;
    $[7] = toast;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== toastError) {
    t3 = error => {
      toastError({
        error
      });
    };
    $[9] = toastError;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useMutation(t4);
};